import React from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import ReadingListCard from "./ReadingListCard";
import noData from "../illustrations/undraw_no_data_qbuo.svg";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  readingCardList: {
    margin: "auto",
  },
}));

export default function ReadingList() {
  const classes = useStyles();
  const readingList = useSelector((state) => state.readingList);

  const renderReadingList = () => {
    if (_.toArray(readingList).length > 0) {
      return (
        <div className={classes.root}>
          <Grid container spacing={3}>
            {renderCard()}
          </Grid>
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <div style={{ display: "flex", marginTop: 16, marginBottom: 12 }}>
            <img
              src={noData}
              alt={"No Items Added to the Reading List Yet."}
              style={{
                width: "40%",
                margin: "auto",
              }}
            ></img>
          </div>
          <Typography align="center" variant="h5" component="h5">
            No Items Added to the Reading List Yet. We're excited to see what
            books you're going to read!
          </Typography>
        </React.Fragment>
      );
    }
  };

  const renderCard = () => {
    return _.toArray(readingList).map((item) => {
      return (
        <Grid item xs={12} sm={6} lg={3} key={item.id}>
          <ReadingListCard
            key={item.id}
            id={item.id}
            title={item.title}
            rating={item.rating}
            cover={item.cover}
          />
        </Grid>
      );
    });
  };

  return <div>{renderReadingList()}</div>;
}
